/* eslint-disable */
// /src/services/policyService.js
import { db } from "./firebase";
import {
    doc,
    getDoc,
    setDoc,
    serverTimestamp,
} from "firebase/firestore";



/**
 * 정책 문서를 한 번만 읽어오는 함수
 * @param {"termsOfUse"|"privacyPolicy"} id
 */
export async function getPolicyOnce(id) {
    const ref = doc(db, "policies", id);
    const snap = await getDoc(ref);
    if (!snap.exists()) {
        return {
            id,
            content: "",
            updatedAt: null,
        };
    }
    const data = snap.data() || {};
    return {
        id,
        content: data.content || "",
        updatedAt: data.updatedAt || null,
    };
}

/**
 * 정책 문서 저장 (content 통으로 저장)
 * @param {"termsOfUse"|"privacyPolicy"} id
 * @param {string} content
 * @param {string} [updatedBy] - 관리자 식별자(이메일 등, 옵션)
 */
export async function savePolicy(id, content, updatedBy) {
    const ref = doc(db, "policies", id);
    const payload = {
        content: content || "",
        updatedAt: serverTimestamp(),
    };
    if (updatedBy) {
        payload.updatedBy = updatedBy;
    }
    await setDoc(ref, payload, { merge: true });
}
